import { withI18nHelper, AppTextLabel } from '@inwink/i18n';
import * as React from 'react';
import { AppShellHelp } from './appshellhelp';
import { AppShellUser } from './appshelluser';
import { AppShellOnBoarding } from './appshellonboarding';
import type { IAppShellHeaderPartProps } from './appshellheader';
import { licenceExpiration } from "@@customer/pages/home/licencewarning";
import { AppCommandPromptContext } from '@@components/appcommandprompt/appcommandpromptcontext';
import type { Entities } from '@inwink/entities/entities';
import { AppShellHeaderActionButton } from './appshellheaderactionbutton';
import { AsyncButton } from '@inwink/buttons';

import './appshellheader.side.less';

@withI18nHelper()
export class AppShellHeaderSide extends React.Component<IAppShellHeaderPartProps, any> {
    popoverparent = React.createRef<HTMLButtonElement>();

    modal: any;

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    openPreview = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        if (this.props.event?.eventdetail) {
            return import('@@event/data/openpreview').then((mod) => {
                return mod.openEventPreview(this.props.event?.eventdetail);
            });

        } else if (this.props.community?.detail) {
            return import('@@community/data/openpreview').then((mod) => {
                return mod.openCommunityPreview(
                    this.props.community?.detail
                );
            });

        }
    };

    openCMS = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        if (this.props.event?.eventdetail) {
            return import('@@event/data/openpreview').then((mod) => {
                return mod.openEventCMS(this.props.event?.eventdetail);
            });

        } else if (this.props.community?.detail) {
            return import('@@community/data/openpreview').then((mod) => {
                return mod.openCommunityCMS(
                    this.props.community?.detail
                );
            });
        }
    };

    renderContent(parent?: any) {
        let licenseWarning = null;
        if (this.props.customer?.detail) {
            const licenseInfo = licenceExpiration(this.props.customer);
            if (licenseInfo.secondsLeft !== null) {
                if (licenseInfo.secondsLeft <= 0) {
                    licenseWarning = <div
                        className="customer-warning"
                        title={this.props.i18nHelper.translate("customer.warning.licenseexpired")}
                    >
                        <i className="inwink-warning" />
                    </div>;
                } else if (licenseInfo.secondsLeft <= 5184000 && licenseInfo.secondsLeft > 0) {
                    licenseWarning = <div
                        className="customer-warning"
                        title={this.props.i18nHelper.translate(licenseInfo.i18n, { days: licenseInfo.inject.days })}
                    >
                        <i className="inwink-warning" />
                    </div>;
                }
            }
        }
        const onBoarding = inwink.config.env !== "prod"
            ? <AppShellOnBoarding {...this.props} afterClick={this.hide} parent={parent} />
            : null;
        const desktopRender = this.props.visualstate.indexOf("M") >= 0;
        let tinyUrl;
        let previewUrl;
        let computedUrl;
        if (this.props.event?.eventdetail) {
            if (this.props.rights?.event?.rights?.bo?.websitecms?.access) {
                tinyUrl = this.props.event.eventdetail.eventKey || this.props.event.eventdetail.tinyUrl
                    || this.props.event.detail?.tinyUrl;
            }
            computedUrl = this.props.event.eventdetail.computedUrl;
            previewUrl = true;
        } else if (this.props.community?.detail) {
            // TODO Community rights
            tinyUrl = this.props.community.detail.communityKey;
            computedUrl = this.props.community.detail.computedUrl;
            previewUrl = true;
        }
        const actions = <div className="websiteactions">
            {/* {tinyUrl ? <Link
                    role="button"
                    to={`/preview/${tinyUrl}`}
                    target="_blank" className='simple'
                ><AppTextLabel i18n="appheaderactions.opencms" /></Link>
                    : null} */}
            {tinyUrl && desktopRender
                ? <AsyncButton onClick={this.openCMS} className='simple'>
                    <AppTextLabel i18n="appheaderactions.opencms" />
                </AsyncButton>
                : null}
            {previewUrl
                ? <AsyncButton onClick={this.openPreview} className='simple'>
                    <div className='icon'>
                        <i className='inwink-web' />
                    </div>
                    <AppTextLabel i18n="appheaderactions.openpreview" />
                </AsyncButton>
                : null}
            {computedUrl
                ? <a role="button" href={computedUrl} target="_blank" rel="noreferrer" className='simple'>
                    <div className='icon'>
                        <i className='inwink-web' />
                    </div>
                    <AppTextLabel i18n="appheaderactions.openwebsitepublished" /></a>
                : null}
        </div>;
        return <div className="app-header-side">
            {licenseWarning}
            {actions}            
            {onBoarding}
            <SearchButton i18nHelper={this.props.i18nHelper} />
            <AppShellUser {...this.props} afterClick={this.hide} parent={parent} />
            <AppShellHelp
                {...this.props}
                afterClick={this.hide}
                parent={parent}
                display={desktopRender ? 'simple' : 'advanced'}
            />
        </div>;
    }

    hide = () => {
        if (this.modal) {
            this.modal.close();
            this.modal = null;
        }
    };

    showMore = (arg: React.MouseEvent<any>) => {
        arg.stopPropagation();
        arg.preventDefault();
        const elt = arg.currentTarget;
        this.modal = this.props.popovermgr.popoverPortal(elt, () => this.renderContent(elt),
            this.props, "app-header-side-popover",
            {
                closeOnResize: true
            });

        this.modal.then(() => {
            this.modal = null;
        });
    };

    render() {
        if (this.props.visualstate.indexOf("M") >= 0) {
            return this.renderContent();
        }

        return <div className="app-header-side">
            <button type="button" className="showmore" ref={this.popoverparent} onClick={this.showMore}>
                <i className="inwink-more-v" /></button>
        </div>;
    }
}


// eslint-disable-next-line @typescript-eslint/no-unused-vars
function SearchButton(props: { i18nHelper: Entities.i18nHelper; }) {
    const command = React.useContext(AppCommandPromptContext);
    const currentDefault = command.defaultKey();
    if (!command.isSearcheable() || !currentDefault) {
        return null;
    }

    return <AppShellHeaderActionButton
        icon="inwink-search"
        onClick={(arg) => {
            arg.preventDefault();
            command.triggerFor(currentDefault);
        }}
        title="actions.search"
        className="searchmenu"
    />;

    // return <button className="clickable action-btn searchmenu"
    // title={props.i18nHelper.translate("actions.search") + " (Ctrl + " + currentDefault.toUpperCase() + ")"} onClick={(arg) => {
    //     arg.preventDefault();
    //     command.triggerFor(currentDefault);
    // }}>
    //     <div className="icon">
    //         <i className="inwink-search" />
    //     </div>
    // </button>;
}
export default AppShellHeaderSide;